export class BillingAPI {
  private static readonly BASE_URL = "/api/v1/billing";
  private static readonly ENDPOINTS = {
    checkCredits: "/credits/check",
  } as const;

  private static readonly HEADERS = {
    contentType: "Content-Type",
    jsonContentType: "application/json",
  } as const;

  /**
   * Checks if user has sufficient credits for a specific action
   * @param action - Type of action to check credits for (e.g., 'search_email_export')
   * @param quantity - Number of credits needed for the action
   * @throws Error if the fetch request fails
   */
  static async checkCreditsAvailability(action: string, quantity: number): Promise<boolean> {
    try {
      const params = new URLSearchParams({
        action,
        quantity: quantity.toString(),
      });

      const response = await fetch(`${this.BASE_URL}${this.ENDPOINTS.checkCredits}?${params.toString()}`, {
        method: "GET",
        headers: {
          [this.HEADERS.contentType]: this.HEADERS.jsonContentType,
        },
        credentials: "include",
      });

      if (!response.ok) {
        throw new Error(`${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      return data.affordable;
    } catch (error) {
      console.error("Check credits availability error:", error);
      throw new Error(
        `Failed to check credits availability: ${error instanceof Error ? error.message : "Unknown error"}`,
      );
    }
  }
}
